import React from "react";
import Intro from "./Intro";
import FeatureOne from "./FeatureOne";
import FeatureTwo from "./FeatureTwo";
import FeatureThree from "./FeatureThree";
import FeatureFour from "./FeatureFour";

import MetaTags from "react-meta-tags";
import FaqsContainer from "../../../Common/component/FAQs";
function Analytics({ faqList }) {
  return (
    <>
      <MetaTags>
        <title>ESG Analytics | ESG Data Analytics Software</title>
        <meta
          name="description"
          content="Updapt ESG Data Analytics Software effectively Identifies and Prioritizes ESG Issues and it converts ESG Data into valuable insights. Get the Right Strategy by Updapt ESG Data Analytics Software."
        />
        <meta
          property="og:title"
          content="ESG Analytics | ESG Data Analytics Software"
        />
        <meta
          property="og:image"
          content="%PUBLIC_URL%/static/media/banner.jpg"
        />
      </MetaTags>

      <Intro></Intro>
      <FeatureOne></FeatureOne>
      <FeatureTwo />
      <FeatureThree />
      <FeatureFour />
      <FaqsContainer faqList={faqList} />
    </>
  );
}

export default Analytics;
